module.exports = __webpack_public_path__ + "static/media/LMC2.f06243dd.png";